import * as React from 'react';
import {
	Link,
	useLocation,
	useParams,
} from "react-router-dom"
import {
  Drawer,
  AppBar,
  CssBaseline,
  Box,
  Toolbar,
  List,
  ListItem,
  ListItemButton,
} from "@mui/material"
import HomeTwoToneIcon from '@mui/icons-material/HomeTwoTone';
import UploadFileTwoToneIcon from '@mui/icons-material/UploadFileTwoTone';
import AutoAwesomeMotionTwoToneIcon from '@mui/icons-material/AutoAwesomeMotionTwoTone';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import StorageTwoToneIcon from '@mui/icons-material/StorageTwoTone';
import TimelineOutlinedIcon from '@mui/icons-material/TimelineOutlined';
import CurrentClientContext from '../../providers/CurrentClientProvider';
import CopyAllOutlinedIcon from '@mui/icons-material/CopyAllOutlined';
import AssessmentIcon from '@mui/icons-material/Assessment';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import _ from 'underscore'
import {LibraryBooks, SupportAgent} from "@mui/icons-material";
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import UserService from "../../services/UserService";
import {useRef, useState} from "react";

const cssInJs = {
	nav: {
		backgroundColor: "#422e52",
		color: 'white',
		boxSizing: 'border-box',
		mt: '50px',
		overflow:'visible',
		borderRadius: 0,
		'::-webkit-scrollbar': {
			width: 0,
		}
	},
	navItem: {
		flexDirection: 'column',
		alignItems: 'center',
		color: 'rgba(255,255,255,0.6)',
		transition: 'all 0.3s',
		fontSize: 12,
		p: 0,
		borderBottom: '1px solid rgba(255,255,255,0.1)',
		py: 1,
		':hover': {
			color: 'rgba(255,255,255,1)',
		},
		'& .active': {
			color: 'rgba(255,255,255,1)',
		},
	},
	navItemSection: {
		position: 'relative',
		'.subNav': {
			display:'none',
			position: 'absolute',
			left:79,
			top: 0,
			width: '200px',
			backgroundColor: '#422e52',
			fontSize: 12,
			'.subItem': {
				borderBottom:'1px solid rgba(255,255,255,0.1)',
			},
			'.subItem:last-child': {
				borderBottom: 'none'
			}
		},
		":hover": {
			'.subNav': {
				display:'block',
			}
		},
	},
	navItemIcon: {
		fontSize: '26px',
		mb: 0.5,
	},
}

function NavContent(props) {
	const currentClient = CurrentClientContext.useClient()

	React.useEffect(() => {
	}, [])

	const getZendLink = () => {
		UserService.getZendUrl().then(res => {
			if(res.url) {
				window.open(res.url, '_blank', 'location=no')
			}
		})
	}

	return <>
		<List disablePadding >
			<ListItem disableGutters disablePadding >
				<ListItemButton component={Link} sx={cssInJs.navItem} to='/'>
					<HomeTwoToneIcon sx={cssInJs.navItemIcon}/>
					Home
				</ListItemButton>
			</ListItem>
			<ListItem disableGutters disablePadding sx={cssInJs.navItemSection}>
				<ListItemButton component={Link} sx={cssInJs.navItem} to={`/plan/copy`}>
					<CopyAllOutlinedIcon sx={cssInJs.navItemIcon}/>
					Copy Plan
				</ListItemButton>
			</ListItem>
      <ListItem disableGutters disablePadding sx={cssInJs.navItemSection}>
				<ListItemButton component={Link} sx={cssInJs.navItem} to={`/client/setup`}>
					<LocalHospitalIcon sx={cssInJs.navItemIcon}/>
					Add Client
				</ListItemButton>
			</ListItem>
			{!_.isEmpty(currentClient.client) && 
				<>
					{/* <ListItem disableGutters disablePadding sx={cssInJs.navItemSection}>
						<ListItemButton component={Link} sx={cssInJs.navItem} to={`/clients/${currentClient.client.ClientCode}/plan/locationclasses/default`}>
							<TimelineOutlinedIcon sx={cssInJs.navItemIcon}/>
							Plan
						</ListItemButton>
					</ListItem> */}
					<ListItem disableGutters disablePadding sx={cssInJs.navItemSection}>
						<ListItemButton className={'menu-item'} component={Link} sx={cssInJs.navItem} to={`/clients/${currentClient.client.ClientCode}/kpi/${currentClient.client.Id}`}>
							<AssessmentIcon sx={cssInJs.navItemIcon}/>
							KPI
						</ListItemButton>
					</ListItem>
					<ListItem disableGutters disablePadding sx={cssInJs.navItemSection}>
						<ListItemButton component={Link} sx={cssInJs.navItem} to={`/clients/${currentClient.client.ClientCode}/analytics/${currentClient.client.Id}`}>
							<AssessmentIcon sx={cssInJs.navItemIcon}/>
							Analytics
						</ListItemButton>
					</ListItem>
					<ListItem disableGutters disablePadding sx={cssInJs.navItemSection}>
						<ListItemButton component={Link} sx={cssInJs.navItem} to={`/clients/${currentClient.client.ClientCode}/report-library/${currentClient.client.Id}`}>
							<LibraryBooksIcon sx={cssInJs.navItemIcon}/>
							Report Library
						</ListItemButton>
					</ListItem>
					<ListItem disableGutters disablePadding sx={cssInJs.navItemSection}>
						<ListItemButton component={Link} sx={cssInJs.navItem} to={`/clients/${currentClient.client.ClientCode}/upload-data`}>
							<StorageTwoToneIcon sx={cssInJs.navItemIcon}/>
							Data
						</ListItemButton>
						<Box className="subNav">
							<ListItemButton component={Link} to={`/clients/${currentClient.client.ClientCode}/upload-data`} className="subItem">Upload Data</ListItemButton>
						</Box>
					</ListItem>
					<ListItem disableGutters disablePadding sx={cssInJs.navItemSection}>
						<ListItemButton component={Link} sx={cssInJs.navItem} to={`/clients/${currentClient.client.ClientCode}/plan/locationclasses/default`}>
							<TimelineOutlinedIcon sx={cssInJs.navItemIcon}/>
							Plan
						</ListItemButton>
						<Box className="subNav">
							<ListItemButton component={Link} to={`/clients/${currentClient.client.ClientCode}/planninig/${currentClient.client.Id}/preview`} className="subItem">Plan Preview</ListItemButton>
						</Box>
					</ListItem>
					{/* <ListItem disableGutters disablePadding sx={cssInJs.navItemSection}>
					<ListItemButton component={Link} sx={cssInJs.navItem} to={`/clients/${currentClient.client.ClientCode}/planninig/${currentClient.client.Id}/preview`}> <StorageTwoToneIcon sx={cssInJs.navItemIcon}/>Plan Preview</ListItemButton>
					</ListItem> */}
					{/* <ListItem disableGutters disablePadding sx={cssInJs.navItemSection}>
						<ListItemButton component={Link} sx={cssInJs.navItem} to={`/clients/${currentClient.client.ClientCode}/planninig/${currentClient.client.Id}/preview`}>
							<StorageTwoToneIcon sx={cssInJs.navItemIcon}/>
							Planning
						</ListItemButton>
						<Box className="subNav">
							<ListItemButton component={Link} to={`/clients/${currentClient.client.ClientCode}/planninig/${currentClient.client.Id}/preview`} className="subItem">Plan Preview</ListItemButton>
						</Box>
					</ListItem> */}
					<ListItem disableGutters disablePadding sx={cssInJs.navItemSection}>
						<ListItemButton component={Link} sx={cssInJs.navItem} to={`/clients/${currentClient.client.ClientCode}/profile`}>
							<BusinessOutlinedIcon sx={cssInJs.navItemIcon}/>
							Profile
						</ListItemButton>
						<Box className="subNav">
							<ListItemButton component={Link} to={`/clients/${currentClient.client.ClientCode}/locations`} className="subItem">Locations</ListItemButton>
							<ListItemButton component={Link} to={`/clients/${currentClient.client.ClientCode}/classes`} className="subItem">Classes</ListItemButton>
							<ListItemButton component={Link} to={`/clients/${currentClient.client.ClientCode}/categories`} className="subItem">Categoies</ListItemButton>
							<ListItemButton component={Link} to={`/clients/${currentClient.client.ClientCode}/import-class`} className="subItem">Import Class</ListItemButton>
							<ListItemButton component={Link} to={`/clients/${currentClient.client.ClientCode}/master-class`} className="subItem">Master Class</ListItemButton>
							<ListItemButton component={Link} to={`/clients/${currentClient.client.ClientCode}/tags`} className="subItem">Tags</ListItemButton>
							<ListItemButton component={Link} to={`/clients/${currentClient.client.ClientCode}/pos-mapping`} className="subItem">POS Mapping</ListItemButton>
						</Box>
					</ListItem>
					<ListItem disableGutters disablePadding sx={cssInJs.navItemSection}>
						<ListItemButton component={Box} sx={cssInJs.navItem} onClick={e => getZendLink()}>
							<SupportAgent sx={cssInJs.navItemIcon}/>
							Zendesk
						</ListItemButton>
					</ListItem>
				</>
			}
		</List>
	</>
}

function LeftNav(props) {
	return (
		<Box component="nav" sx={{ width: { sm: props.width }, flexShrink: { sm: 0 } }}>
			<Drawer
        variant="temporary"
        open={props.navOpen}
        onClose={() => {props.onNavClose()}}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          display: { xs: 'block', sm: 'none' },
          '& .MuiDrawer-paper': { 
          	width: props.width,
          	...cssInJs.nav,
          },
        }}
      >
        <NavContent />
      </Drawer>
      <Drawer 
        variant="permanent" 
        sx={{
          display: { xs: 'none', sm: 'block' }, 
          '& .MuiDrawer-paper': { 
          	width: props.width,
          	...cssInJs.nav,
          },
        }}
      >
        <NavContent />
      </Drawer>
		</Box>
	)
}

export default LeftNav